module.exports = __webpack_public_path__ + "static/iPresta-4eed0d5a82ed870042f6db8f2b219727.png";